import validationReglesAchat from '@/services/catalogue/validation/validationReglesAchat';
import validationSecteur from '@/services/commun/secteur/validationSecteur';

export default function validation(response, messages, contratsMateriels) {
  if (!response.data || !response.data.error || !response.data.error.validationErrors) {
    return;
  }
  validationSecteur(response, messages);
  response.data.error.validationErrors.forEach((error) => {
    const message = error.message;
    const numLigne = message.split('__');
    let preMessage = null;
    if (numLigne[1]) {
      preMessage = { message: 'importDonne.numLigne', parametres: { num: numLigne[1] } };
    }
    if (message.indexOf('SAVED_STATE_REQUIRED') !== -1 && messages.filter((error) => { return error.message === 'ajoutEditContrat.messages.errors.stateSavedRequired'; }).length === 0) {
      messages.push({
        message: 'ajoutEditContrat.messages.errors.stateSavedRequired',
        preMessage,
      });
    }
    if (message.indexOf('LEAST_ONE_PRODUCT') !== -1 && messages.filter((error) => { return error.message === 'ajoutEditContrat.messages.errors.leastOneProduct'; }).length === 0) {
      messages.push({
        message: 'ajoutEditContrat.messages.errors.leastOneProduct',
        preMessage,
      });
    }
    if (message.indexOf('ECH_DATE_START_GREATER_THAN_END_DATE') === 0) {
      messages.push({
        message: 'ajoutEditContrat.messages.errors.dateDebutGreaterDateFin',
        preMessage,
      });
    }
    if (message.indexOf('ECH_DUEDATE_OUTSIDE_RANGE') === 0) {
      messages.push({
        message: 'ajoutEditContrat.messages.errors.dateEcheanceOutside',
        preMessage,
      });
    }
    if (message.indexOf('SHOULD_HAVE_PRODUCT_RENT_ID') === 0) {
      messages.push({
        message: 'ajoutEditContrat.messages.errors.productRentRequired',
        preMessage,
      });
    }
    if (message.indexOf('POURCENTAGE_DIVISION') === 0) {
      messages.push({
        message: 'ajoutEditContrat.messages.errors.mustHaveIntervenant',
        preMessage,
      });
    }
    if (message.indexOf('NON_NUMERIC_MATERIEL_SHOULD_HAVE_A_FACE') === 0) {
      const splitMessage = message.split('|')[0].split('@');
      const materiel = contratsMateriels.find((contratMateriel) => {
        return contratMateriel.materielId === splitMessage[1];
      });
      messages.push({
        message: 'ajoutEditContrat.messages.errors.materielWithoutFace',
        parametres: {
          code: materiel ? materiel.materiel.code : '',
        },
        preMessage,
      });
    }
    if (message.indexOf('INVOICE_CODE_MUST_BE_REPLACED_FULLY') === 0) {
      const code = message.split('|')[0].split('@')[1];
      messages.push({
        message: 'ajoutEditContrat.messages.errors.invoiceCodeMustBeReplacedFully',
        parametres: {
          code: code,
        },
        preMessage,
      });
    }
    if (message.indexOf('CODE_REQUIRED_IF_MASK_NOT_SET_ON_COMPANY') === 0) {
      messages.push({
        message: 'ajoutEditContrat.messages.errors.codeRequired',
        preMessage,
      });
    }
    if (message.indexOf('UNABLE_TO_GENERATE_IF_DISPOSITIF_WITHOUT_ADDRESS') === 0) {
      const contrat = message.split('|')[0].split('@')[1];
      const dispositifs = message.split('|')[0].split('@')[2];
      messages.push({
        message: 'ajoutEditContrat.messages.errors.dispositifWithoutAddress',
        parametres: {
          codeContrat: contrat,
          codesDispositifs: dispositifs,
        },
        preMessage,
      });
    }
    if (message.indexOf('CONTRAT_INDEXATION_MontantIndexationReference') === 0) {
      messages.push({
        message: 'ajoutEditContrat.messages.errors.notFilledMontantIndexationReference',
        preMessage,
      });
    }
    if (message.indexOf('CONTRAT_INDEXATION_NOT_BEEN') === 0) {
      messages.push({
        message: 'ajoutEditContrat.messages.errors.notFilledMontantIndexationReference',
        preMessage,
      });
    }
    if (message.indexOf('CONTRAT_INDEXATION_TypeIndexation') === 0) {
      messages.push({
        message: 'ajoutEditContrat.messages.errors.notFilledTypeIndexation',
        preMessage,
      });
    }
    if (message.indexOf('CONTRAT_INDEXATION_ValeurIndexationActuel') === 0) {
      messages.push({
        message: 'ajoutEditContrat.messages.errors.notFilledValeurIndexationActuel',
        preMessage,
      });
    }
    if (message.indexOf('CONTRAT_INDEXATION_ValeurIndexationReference') === 0) {
      messages.push({
        message: 'ajoutEditContrat.messages.errors.notFilledValeurIndexationReference',
        preMessage,
      });
    }
    if (message.indexOf('CONTRACT_NOT_SAME_COMPANY_LESSOR') === 0) {
      messages.push({
        message: 'ajoutEditContrat.messages.errors.notSameCompanyLessor',
        preMessage,
      });
    }
    if (message.indexOf('CONTRACT_NOT_SAME_COMPANY_BILLEBOARD') === 0) {
      messages.push({
        message: 'ajoutEditContrat.messages.errors.notSameCompanyBillboard',
        preMessage,
      });
    }
    if (message.indexOf('SECTEUR_MATERIEL_AND_BAIL_NOTMATCH') === 0) {
      messages.push({
        message: 'ajoutEditContrat.messages.errors.notMatchSecteur',
        preMessage,
      });
    }
    if (message.indexOf('SECTEUR_MATERIELS_AND_BAUX_NOTMATCH') === 0) {
      const splitMessage = message.split('|')[0].split('@');
      const codes = splitMessage[1].replace('[', '').replace(']', '').split(',').join(', ');
      messages.push({
        message: 'listeContrat.popUpAjoutSecteur.notMatchSecteur',
        parametres: {
          codes: codes,
        },
        preMessage,
      });
    }
    validationReglesAchat(message, messages);
  });
}
